var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var OverheadAPI = /** @class */ (function (_super) {
    __extends(OverheadAPI, _super);
    function OverheadAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverheadAPI.prototype.listEmployeeRates = function () { return this.fetchPaginated("/api/employee-overhead/list", {}); };
    OverheadAPI.prototype.updateEmployeeRate = function (props) { return this.fetcher.post("/api/employee-overhead/update", props); };
    OverheadAPI.prototype.createEmployeeRate = function (props) { return this.fetcher.post("/api/employee-overhead/create", props); };
    OverheadAPI.prototype.removeEmployeeRates = function (props) { return this.fetcher.post("/api/employee-overhead/remove", props); };
    OverheadAPI.prototype.listContractorRates = function () { return this.fetchPaginated("/api/contractor-overhead/list", {}); };
    OverheadAPI.prototype.updateContractorRate = function (props) { return this.fetcher.post("/api/contractor-overhead/update", props); };
    OverheadAPI.prototype.createContractorRate = function (props) { return this.fetcher.post("/api/contractor-overhead/create", props); };
    OverheadAPI.prototype.removeContractorRates = function (props) { return this.fetcher.post("/api/contractor-overhead/remove", props); };
    return OverheadAPI;
}(SubAPI));
export { OverheadAPI };
